import React, { useEffect } from 'react'

import ItemModal from 'public/components/default_template/online_ordering/item_modal/ItemModal'

import { useReorder } from './ReorderContext'
import { ItemSource } from '../cart/cartUtils'

const ItemModalWrapper: React.FC = () => {
  const {
    reorderItem,
    onHistoryClose,
    clearReorderItem,
    isReorderItemOpen,
    onReorderItemOpen,
    onReorderItemClose
  } = useReorder()

  useEffect(() => {
    // We want to close the history modal whenever we open the item modal.
    if (reorderItem) {
      onReorderItemOpen()
      onHistoryClose()
    }
  }, [reorderItem, onHistoryClose, onReorderItemOpen])

  return (
    <ItemModal
      isOpen={isReorderItemOpen && !!reorderItem}
      onClose={() => {
        onReorderItemClose()
        clearReorderItem()
      }}
      orderGuid={reorderItem?.orderGuid}
      selectionGuid={reorderItem?.selection.guid}
      itemGuid={reorderItem?.selection.itemGuid}
      itemGroupGuid={reorderItem?.selection.itemGroupGuid}
      itemSource={ItemSource.Reorder}
    />
  )
}

export default ItemModalWrapper
